import axiosInstance from "./AxiosInstance";

/**
 * Create or update GST settings.
 *
 * API expects:
 * - cgst
 * - sgst
 * - total_gst
 * - update_type ("Base Price" | "MRP")
 * - id (optional, for updates)
 */
export function updateGST({ cgst, sgst, total_gst, update_type, id }) {
  const payload = {
    cgst,
    sgst,
    total_gst,
    update_type,
    ...(id ? { id } : {}),
  };

  return axiosInstance.post("/admin/updateGST", payload);
}

/**
 * Fetch GST update history/list.
 *
 * Example API: GET /admin/gstUpdatedList
 */
export function getGSTUpdatedList() {
  // This endpoint expects a POST request in most cases (for list endpoints).
  // If the backend uses GET, this can be changed back.
  return axiosInstance.post("/admin/gstUpdatedList", {});
}
